import { RouteConfig } from 'vue-router';

const BusinessView = () => import('@/views/business.vue');
const BusinessViewIndex = () => import('@/views/business/index.vue');

const TaxPayersView = () => import('@/views/business/tax-payers.vue');
const TaxPayersViewIndex = () =>
  import('@/views/business/tax-payers/index.vue');

const PartnersView = () => import('@/views/business/partners.vue');
const PartnersViewIndex = () => import('@/views/business/partners/index.vue');

const InfoView = () => import('@/views/info/stats/index.vue');
const ReportsView = () => import('@/views/reports/index.vue');

export default {
  path: '/business',
  component: BusinessView,
  meta: {
    name: 'page.business',
  },
  children: [
    {
      path: '',
      name: 'business-index',
      redirect: { name: 'business-taxpayers-index' },
      component: BusinessViewIndex,
    },
    {
      path: 'taxpayers',
      component: TaxPayersView,
      children: [
        {
          path: '',
          name: 'business-taxpayers-index',
          component: TaxPayersViewIndex,
          meta: {
            name: 'section.taxPayers',
          },
        },
      ],
    },
    {
      path: 'partners',
      component: PartnersView,
      children: [
        {
          path: '',
          name: 'business-partners-index',
          component: PartnersViewIndex,
          meta: {
            name: 'section.partners',
          },
        },
      ],
    },
    {
      path: 'info',
      component: InfoView,
      name: 'business-info-index',
      meta: {
        name: 'section.info',
      },
    },
    {
      path: 'reports',
      component: ReportsView,
      meta: {
        name: 'section.reports',
      },
    },
  ],
} as RouteConfig;
